import React from "react";
import { useAsyncFn } from "./use_async_fn";

export type AsyncState<T> =
  | {
      loading: boolean;
      error?: undefined;
      data?: undefined;
    }
  | {
      loading: false;
      error: Error;
      data?: undefined;
    }
  | {
      loading: false;
      error?: undefined;
      data: T;
    };

export function useAsync<TResult = any>(
  fn: () => Promise<TResult>,
  deps: React.DependencyList = []
) {
  const [state, callback] = useAsyncFn<TResult>(fn, deps, {
    loading: true,
  });

  React.useEffect(() => {
    callback();
  }, [callback]);

  return state;
}
